import React from 'react';
import PanelSection from '../../FormElements/PanelSection';
import DateDataType from '../../DataTable2/DataTypes/DateDataType';

export default class UserPersonalData extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			title,
			personalData,
			onShowUserPersonalDataEditCardPopup
		} = this.props;

		let hasPersonalData = personalData && personalData.fields;

		let section = null;
		if (hasPersonalData) {
			const fieldElements = this.props.personalData.fields.map(
				(field, index) => {
					const fieldValue = field.value !== null ? field.value.asString : '-';

					const hideIfNull = field.hideIfNull || false;

					if (hideIfNull && fieldValue === '-') {
						return null;
					}

					return (
						<div className="data-group" key={index}>
							<label>{field.displayName}</label>
							<span>
								{field.type === 'DATE' ? (
									<DateDataType
										value={fieldValue !== '-' ? fieldValue : undefined}
									/>
								) : (
									fieldValue
								)}
							</span>
						</div>
					);
				}
			);

			section = (
				<div className="UserPersonalInfo">
					<PanelSection
						title={title}
						onClickShowPopup={onShowUserPersonalDataEditCardPopup}
					>
						<div>{fieldElements}</div>
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				<div>{section}</div>
			</div>
		);
	}
}
